const { fetchAuthorizedJsonApi, fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

function fetchDailyQuests(apiUrl) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/daily-tasks',
    query: { lang: getApiLanguage(), version: '2' },
    expectedStatus: 200,
    description: 'Fetching daily quests',
  });
}

function fetchCurrentInterval(apiUrl) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/daily-boost',
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching interval quests',
  });
}

function fetchQuestsProgres(apiUrl, token) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: 'v1/daily-tasks/progress',
    expectedStatus: 200,
    description: 'Fetching quest progress',
  });
}

function fetchIntervalProgress(apiUrl, token) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: 'v1/daily-boost/progress',
    expectedStatus: 200,
    description: 'Fetching progress of interval',
  });
}

function claimDaily(apiUrl, token, _id) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/daily-tasks/${_id}/claim`,
    expectedStatus: 200,
    description: 'Claiming daily reward',
  });
}

function claimIntervalReward(apiUrl, token, captchaToken) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: 'v1/daily-boost/claim',
    body: {
      'g-recaptcha-response': captchaToken,
    },
    expectedStatus: 200,
    description: 'Claiming interval reward',
  });
}

function claimIDFAReward(apiUrl, token, placementId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: 'v1/users/self/promo-video',
    body: {
      placementId,
    },
    expectedStatus: 204,
    description: 'Claiming reward for IDFA agreement ad',
  });
}

module.exports = {
  fetchDailyQuests,
  fetchQuestsProgres,
  claimDaily,
  claimIDFAReward,
  fetchCurrentInterval,
  fetchIntervalProgress,
  claimIntervalReward,
};
